import { FilterGroup } from '@/service/type/Filter';
import { cn } from '@/utils';
import React, { useRef } from 'react';
import FilterCard from './FilterCard';
import { FilterGroupListResponse } from '@/service/filter';

const FilterCards: React.FC<{ getStyleFilterGroupData?: FilterGroupListResponse }> = ({ getStyleFilterGroupData }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const CARD_WIDTH = 280;
  const CARDS_GAP = 16;

  const handleScroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const scrollAmount = CARD_WIDTH + CARDS_GAP;
      const isAtEnd = Math.abs(container.scrollWidth - container.clientWidth - container.scrollLeft) <= 1;
      const isAtStart = container.scrollLeft <= 0;

      if (direction === 'right' && isAtEnd) {
        container.scrollTo({
          left: 0,
          behavior: 'smooth',
        });
      } else if (direction === 'left' && isAtStart) {
        container.scrollTo({
          left: container.scrollWidth - container.clientWidth,
          behavior: 'smooth',
        });
      } else {
        const newScrollPosition = container.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount);
        container.scrollTo({
          left: newScrollPosition,
          behavior: 'smooth',
        });
      }
    }
  };

  return (
    <div className="px-4">
      <div className="flex flex-col">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-[1.15rem] font-normal leading-[1.25rem] tracking-[-3%]">Featured StyleFilters™</h2>
          <div className="flex gap-2">
            <button onClick={() => handleScroll('left')} className="w-10 h-10 bg-[#f2f2f2] rounded-full flex items-center justify-center">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
            <button onClick={() => handleScroll('right')} className="w-10 h-10 bg-[#f2f2f2] rounded-full flex items-center justify-center">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          </div>
        </div>

        <div ref={scrollContainerRef} className={cn('flex overflow-x-auto gap-4 scroll-smooth hide-scrollbar', '-mx-4 px-4')}>
          {getStyleFilterGroupData?.data?.map((item: FilterGroup) => {
            return <FilterCard key={item.id} data={item} className="w-[262px] h-fit" />;
          })}
        </div>
      </div>
    </div>
  );
};

export default FilterCards;
